export enum eSSSection {
  financial_consideration = 'financial_consideration',
  loan_charges_to_lender = 'loan_charges_to_lender',
  gross_transaction_fee = 'gross_transaction_fee',
  escrow_title_charges = 'escrow_title_charges',
  other_loan_charges = 'other_loan_charges',
  recording_fees_and_transfer_taxes = 'recording_fees_and_transfer_taxes',
  commissions_other = 'commissions_other',
  prorations_adjustments = 'prorations_adjustments',
  payoffs = 'payoffs',
  subtotals = 'subtotals',
  totals = 'totals',
  balance_borrower = 'balance_borrower',
  balance_buyer = 'balance_buyer',
  balance_seller = 'balance_seller',
  investment_amount = 'investment_amount',
}
